// src/data/publicRoutes.data.js
export const publicRoutes = [
    {
        path: "/",
        name: "Home",
        component: "Home",
        navItem: false // Don't show in navigation
    },

    {
        path: "/Customer-register",
        name: "Customer Register",
        component: "Register",
        navItem: true,
        className: "nav-link",
        position: "dropdown",
        dropdownName: "Register",
        dropdownType: "register"
    },
    {
        path: "/merchant-register",
        name: "Merchant Register",
        component: "MerchantRegister",
        navItem: true,
        className: "nav-link",
        position: "dropdown",
        dropdownName: "Register",
        dropdownType: "register"
    },
    {
        path: "/about-us",
        name: "About Us",
        component: "AboutUs",
        navItem: true,
        className: "nav-link",
        position: "right"
    },
    {
        path: "/contact",
        name: "Contact Us",
        component: "ContactUs",
        navItem: true,
        className: "nav-link",
        position: "right"
    },
    {
        path: "/faq",
        name: "FAQ",
        component: "FAQ",
        navItem: true,
        className: "nav-link",
        position: "right"
    },
    {
        path: "/privacy-policy",
        name: "Privacy Policy",
        component: "PrivacyPolicy",
        navItem: true
    },
    {
        path: "/terms-of-service",
        name: "Terms of Service",
        component: "TermsOfService",
        navItem: true
    },
    {
        path: "/merchantsolutions",
        name: "Merchant Solutions",
        component: "MerchantSolutions",
        navItem: true,
        className: "nav-link",
        position: "right"
    },
    {
        path: "/customersolutions",
        name: "Customer Solutions",
        component: "CustomerSolutions",
        navItem: false
    },
    {
        path: "/unauthorized",
        name: "Unauthorized",
        component: "Unauthorized",
        navItem: false
    },
    {
        path: "/api-docs",
        name: "API Docs",
        component: "ApiDocumentation",
        navItem: true,
        className: "nav-link",
        position: "right"
    }
];

export const dropdowns = {
    register: {
        name: "Register",
        items: [
            {
                path: "/merchant-register",
                name: "Merchant"
            },

        ]
    }
};